import { Form } from '@tribeplatform/react-components/Form'
import { T, useI18n } from '@tribeplatform/react-components/i18n'
import { useNetwork, useUpdateNetwork } from '@tribeplatform/react-sdk/hooks'
import { Button } from '@tribeplatform/react-ui-kit/Button'
import { Card } from '@tribeplatform/react-ui-kit/Card'
import { toast } from '@tribeplatform/react-ui-kit/Toast'

export const GlobalEnableMessaging = () => {
  const { $t } = useI18n()
  const { data: network } = useNetwork()
  const { mutateAsync: updateNetwork, isLoading } = useUpdateNetwork()

  const { privateMessagingEnabled } = network?.settings?.privateMessaging || {}

  const onSubmit = data => {
    updateNetwork({
      input: {
        settings: {
          privateMessaging: {
            ...network?.settings?.privateMessaging,
            ...data,
          },
        },
      },
    })
      .then(() => {
        toast({
          title: $t({
            defaultMessage: 'Messaging settings updated.',
            id: 'Admin.Messaging.Settings.Updated',
          }),
          status: 'success',
        })
      })
      .catch(() => {
        toast({
          title: $t({
            defaultMessage: 'Unable to update messaging settings.',
            id: 'Admin.Messaging.Settings.FailedToUpdate',
          }),
          status: 'error',
        })
      })
  }

  return (
    <Card>
      <Card.Header
        title={$t({
          defaultMessage: 'Messaging',
          id: 'Generics.Messaging',
        })}
      />
      <Card.Content>
        <Form
          defaultValues={{
            privateMessagingEnabled,
          }}
          onSubmit={onSubmit}
          className="space-y-5"
        >
          {({ formState }) => {
            return (
              <>
                <div className="space-y-3">
                  <Form.Toggle
                    name="privateMessagingEnabled"
                    label={$t({
                      defaultMessage:
                        'Allow private or group messaging within your {COMMUNITY}.',
                      id: 'Admin.Messaging.Settings.Description.Community',
                    })}
                  />
                </div>
                <Form.Actions>
                  <Button
                    type="submit"
                    loading={isLoading}
                    disabled={!formState.isDirty}
                  >
                    <T defaultMessage="Update" id="Generics.Update" />
                  </Button>
                </Form.Actions>
              </>
            )
          }}
        </Form>
      </Card.Content>
    </Card>
  )
}
